module.exports = __webpack_public_path__ + "img/Slide22.b038ee33.png";